import avatarsCamera from './avatars/camera.svg'
import avatarsFemale from './avatars/female.svg'
import avatarsMale from './avatars/male.svg'
import avatarsUnknown from './avatars/unknown.svg'

export const cameraIcon = avatarsCamera
export const femaleAvatar = avatarsFemale
export const maleAvatar = avatarsMale
export const unknownAvatar = avatarsUnknown

export default {
  cameraIcon,
  femaleAvatar,
  maleAvatar,
  unknownAvatar,
}
